import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ModalComponent from '../../components/formComponent/ModalComponent';
import moment from 'moment';
import { Button, Input, message, Spin, Table } from 'antd';
import FormSelect from '../../components/general/FormSelect';
import FormButton from '../../components/general/FormButton';
import { INPUT_SIZE } from '../../common/ThemeConstants';
import FormTextField from '../../components/general/FormTextField';
import FormContainer from '../../components/general/FormContainer';
import { postRequest } from "../../services/mainApp.service";
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import { TERMINAL_UNIQUE_ID } from '../../common/SetupMasterEnum';
import { getDate } from '../../functions/dateFunctions';
import FinancialReportModal from "../../components/PosComponentsFood/FinancialReportModal";
import ProductSaleReportModal from "../../components/PosComponentsFood/ProductSaleReportModal";

const TerminalOpeningReport = React.forwardRef(({ data }, ref) => {
    const formatNumber = (value) => {
        const numericValue = Number(value ?? 0);
        if (Number.isNaN(numericValue)) {
            return "0.00";
        }
        return numericValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    if (!data) {
        return <div ref={ref} />;
    }

    const formattedDateTime = data.openingDateTime
        ? moment(data.openingDateTime).format("YYYY-MM-DD HH:mm:ss")
        : moment().format("YYYY-MM-DD HH:mm:ss");

    return (
        <div
            ref={ref}
            style={{
                padding: "24px",
                fontFamily: "Segoe UI, Helvetica, Arial, sans-serif",
                color: "#000",
                width: "320px",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    marginBottom: "8px",
                    fontSize: "18px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                }}
            >
                {data.companyName || "Terminal Opening Report"}
            </h2>
            <h3
                style={{
                    textAlign: "center",
                    marginBottom: "16px",
                    fontSize: "16px",
                    fontWeight: 500,
                }}
            >
                Terminal Opening Report
            </h3>
            <table
                style={{
                    width: "100%",
                    fontSize: "12px",
                    lineHeight: "18px",
                    borderCollapse: "collapse",
                }}
            >
                <tbody>
                    {data.branchName && (
                        <tr>
                            <td style={{ fontWeight: 600 }}>Branch</td>
                            <td style={{ textAlign: "right" }}>{data.branchName}</td>
                        </tr>
                    )}
                    {data.terminalName && (
                        <tr>
                            <td style={{ fontWeight: 600 }}>Terminal</td>
                            <td style={{ textAlign: "right" }}>{data.terminalName}</td>
                        </tr>
                    )}
                    {data.shiftName && (
                        <tr>
                            <td style={{ fontWeight: 600 }}>Shift</td>
                            <td style={{ textAlign: "right" }}>{data.shiftName}</td>
                        </tr>
                    )}
                    <tr>
                        <td style={{ fontWeight: 600 }}>Opened By</td>
                        <td style={{ textAlign: "right" }}>{data.openedBy || "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 600 }}>Date &amp; Time</td>
                        <td style={{ textAlign: "right" }}>{formattedDateTime}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 600 }}>Opening Amount</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(data.openingAmount)}</td>
                    </tr>


                </tbody>
            </table>

            <div
                style={{
                    marginTop: "24px",
                    fontSize: "11px",
                    textAlign: "center",
                }}
            >
                Generated at {moment().format("YYYY-MM-DD HH:mm:ss")}
            </div>
        </div>
    );
});

const ShiftOpeningReport = React.forwardRef(({ data }, ref) => {
    const formatOptionalValue = (value) =>
        value !== undefined && value !== null && value !== "" ? value : null;

    if (!data) {
        return <div ref={ref} />;
    }

    const formattedDateTime = data.openingDateTime
        ? moment(data.openingDateTime).format("YYYY-MM-DD HH:mm:ss")
        : moment().format("YYYY-MM-DD HH:mm:ss");

    return (
        <div
            ref={ref}
            style={{
                padding: "24px",
                fontFamily: "Segoe UI, Helvetica, Arial, sans-serif",
                color: "#000",
                width: "320px",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    marginBottom: "8px",
                    fontSize: "18px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                }}
            >
                {data.companyName || "Shift Opening Report"}
            </h2>
            <h3
                style={{
                    textAlign: "center",
                    marginBottom: "16px",
                    fontSize: "16px",
                    fontWeight: 500,
                }}
            >
                Shift Opening Report
            </h3>
            <table
                style={{
                    width: "100%",
                    fontSize: "12px",
                    lineHeight: "18px",
                    borderCollapse: "collapse",
                }}
            >
                <tbody>
                    {data.branchName && (
                        <tr>
                            <td style={{ fontWeight: 600 }}>Branch</td>
                            <td style={{ textAlign: "right" }}>{data.branchName}</td>
                        </tr>
                    )}
                    {data.shiftName && (
                        <tr>
                            <td style={{ fontWeight: 600 }}>Shift</td>
                            <td style={{ textAlign: "right" }}>{data.shiftName}</td>
                        </tr>
                    )}

                    <tr>
                        <td style={{ fontWeight: 600 }}>Opened By</td>
                        <td style={{ textAlign: "right" }}>{data.openedBy || "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 600 }}>Date &amp; Time</td>
                        <td style={{ textAlign: "right" }}>{formattedDateTime}</td>
                    </tr>

                </tbody>
            </table>
            <div
                style={{
                    marginTop: "24px",
                    fontSize: "11px",
                    textAlign: "center",
                }}
            >
                Generated at {moment().format("YYYY-MM-DD HH:mm:ss")}
            </div>
        </div>
    );
});

const DayShiftCounterModal = (props) => {
    const {
        isDayShiftCounterModalVisible,
        setIsDayShiftCounterModalVisible,
        setDayShiftCounterData,
        DayShiftCounterData,
        isDayShiftCounterCloseModalVisible,
        setIsDayShiftCounterCloseModalVisible
    } = props;
    const controller = new window.AbortController();
    const userData = useSelector((state) => state.authReducer);
    const [data, setData] = useState({
        BusinessDayId: 0,
        Date: Date.now(),
        ShiftDetailId: 0,
        TerminalDetailId: 0,
        TerminalOpeningAmount: 0,
        TerminalClosingAmount: 0,
        ShiftId: 0,
        TerminalId: 0,
        BranchId: null,
        BranchName: '',
        ShiftName: '',
        TerminalName: '',
        IsTerminalOpen: false,
        IsSelected: false,
    });
    const [modalLoading, setModalLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState({
        DayModal: false,
        ShiftModal: false,
        CounterModal: false
    });
    const POSData = useSelector((state) => state.POSReducer);
    const [selectedShiftInfo, setSelectedShiftInfo] = useState(null);
    const [selectedTerminalInfo, setSelectedTerminalInfo] = useState(null);
    const [pendingTerminalReport, setPendingTerminalReport] = useState(null);
    const [pendingShiftReport, setPendingShiftReport] = useState(null);
    const terminalReportRef = useRef(null);
    const shiftReportRef = useRef(null);
    const [financialModal, setFinancialModal] = useState(false);
    const [financialReportData, setFinancialReportData] = useState(null);
    const [productSaleModal, setProductSaleModal] = useState(false);
    const [productSaleData, setProductSaleData] = useState(null);
    const [financialReportOperationId, setFinancialReportOperationId] = useState(0);
    const [productSaleReportOperationId, setProductSaleReportOperationId] = useState(0);

    const GetFinancialReportData = async (operationId, payload = {}) => {
        try {
            const response = await postRequest(
                '/PosReports',
                {
                    OperationId: operationId,
                    BranchId: data.BranchId,
                    DateFrom: getDate(),
                    DateTo: getDate(),
                    CompanyId: userData.CompanyId,
                    UserId: userData.UserId,
                    ...payload,
                },
                controller
            );

            if (response?.error === true) {
                console.error('FinancialReport error:', response?.errorMessage);
                return null;
            }
            if (response?.data?.response === false) {
                console.error('FinancialReport error:', response?.data?.DataSet?.Table?.errorMessage);
                return null;
            }

            setFinancialReportData(response?.data?.DataSet || null);
            return response?.data?.DataSet || null;
        } catch (error) {
            console.error('FinancialReport API call failed:', error);
            return null;
        }
    };

    const GetProductSaleData = async (operationId, payload = {}) => {
        try {
            const response = await postRequest(
                '/ProductSaleReport',
                {
                    OperationId: operationId,
                    BranchId: data.BranchId,
                    DateFrom: getDate(),
                    DateTo: getDate(),
                    CompanyId: userData.CompanyId,
                    UserId: userData.UserId,
                    ...payload,
                },
                controller
            );

            if (response?.error === true) {
                console.error('ProductSaleReport error:', response?.errorMessage);
                return null;
            }
            if (response?.data?.response === false) {
                console.error('ProductSaleReport error:', response?.data?.DataSet?.Table?.errorMessage);
                return null;
            }

            setProductSaleData(response?.data?.DataSet || null);
            return response?.data?.DataSet || null;
        } catch (error) {
            console.error('ProductSaleReport API call failed:', error);
            return null;
        }
    };

    const handlePrintTerminalOpening = useReactToPrint({
        content: () => terminalReportRef.current,
        documentTitle: pendingTerminalReport
            ? `TerminalOpening_${(pendingTerminalReport.terminalName || "Counter")
                .toString()
                .replace(/\s+/g, "_")}_${moment(pendingTerminalReport.openingDateTime || new Date()).format("YYYYMMDD_HHmm")}`
            : "TerminalOpeningReport",
        onAfterPrint: () => setPendingTerminalReport(null),
        removeAfterPrint: true,
    });

    const handlePrintShiftOpening = useReactToPrint({
        content: () => shiftReportRef.current,
        documentTitle: pendingShiftReport
            ? `ShiftOpening_${(pendingShiftReport.shiftName || "Shift")
                .toString()
                .replace(/\s+/g, "_")}_${moment(pendingShiftReport.openingDateTime || new Date()).format("YYYYMMDD_HHmm")}`
            : "ShiftOpeningReport",
        onAfterPrint: () => setPendingShiftReport(null),
        removeAfterPrint: true,
    });

    useEffect(() => {
        if (pendingTerminalReport) {
            const timeoutId = setTimeout(() => {
                handlePrintTerminalOpening();
            }, 150);

            return () => clearTimeout(timeoutId);
        }
    }, [pendingTerminalReport, handlePrintTerminalOpening]);

    useEffect(() => {
        if (pendingShiftReport) {
            const timeoutId = setTimeout(() => {
                handlePrintShiftOpening();
            }, 150);

            return () => clearTimeout(timeoutId);
        }
    }, [pendingShiftReport, handlePrintShiftOpening]);

    const columns = [
        {
            title: 'Counter Name',
            dataIndex: 'terminalName',
            key: 'terminalName',
        },
        {
            title: 'Opening Amount',
            dataIndex: 'openingAmount',
            key: 'openingAmount',
            render: (text, record) => (
                <FormTextField
                    colSpan={12}
                    placeholder='Opening Amount'
                    style={{ width: '250px' }}
                    label='Opening Amount'
                    required
                    name='TerminalOpeningAmount'
                    type='number'
                    value={data.TerminalClosingAmount}
                    isNumber={true}
                    min='0'
                    onChange={(e) =>
                        setData({ ...data, TerminalClosingAmount: e.value })
                    }
                />
            ),
        },
        {
            title: 'Closing Amount',
            dataIndex: 'closingAmount',
            key: 'closingAmount',
            render: (text, record) => (
                <Input
                    value={record.closingAmount}
                    onChange={(e) =>
                        handleInputChange(e.target.value, record.key, 'closingAmount')
                    }
                />
            ),
        },
    ];

    useEffect(() => {

        if (data.BranchId == 0 || data.BranchId == null) {
            setModalOpen({
                ...modalOpen,
                DayModal: true,
                ShiftModal: false,
                CounterModal: false
            });
        }
    }, []);

    useEffect(() => {


        if (isDayShiftCounterCloseModalVisible == false) {
            if (data.BusinessDayId === 0) {
                setModalOpen({
                    ...modalOpen,
                    DayModal: true,
                    ShiftModal: false,
                    CounterModal: false
                });
            }
            else if (data.ShiftDetailId === 0) {
                setModalOpen({
                    ...modalOpen,
                    DayModal: false,
                    ShiftModal: true,
                    CounterModal: false
                });
            }
            else if (data.TerminalDetailId === 0) {
                setModalOpen({
                    ...modalOpen,
                    DayModal: false,
                    ShiftModal: false,
                    CounterModal: true
                });
            }
            else {
                setModalOpen({
                    ...modalOpen,
                    DayModal: false,
                    ShiftModal: false,
                    CounterModal: false
                });
            }
        }

    }, [data]);

    useEffect(() => {

        if (isDayShiftCounterCloseModalVisible == true && data.BranchId > 0) {

            let terminalId = localStorage.getItem('SelectedTerminalId');

            const DayShiftCounter_Data = DayShiftCounterData?.find(a => a.IsCounterOpen === true
                && a.TerminalId == terminalId);

            if (DayShiftCounter_Data != undefined) {
                if (DayShiftCounter_Data.TerminalDetailId > 0 && DayShiftCounter_Data.ShiftDetailId > 0 && DayShiftCounter_Data.BusinessDayId > 0) {
                    setModalOpen({
                        ...modalOpen,
                        DayModal: false,
                        ShiftModal: false,
                        CounterModal: true
                    });
                }
                else {
                    setModalOpen({
                        ...modalOpen,
                        DayModal: false,
                        ShiftModal: false,
                        CounterModal: false
                    });
                }
            }
            else {
                const DayShiftCounter_Data = DayShiftCounterData?.find(a => a.BranchId === data?.BranchId);

                if (DayShiftCounter_Data.TerminalDetailId == 0 && DayShiftCounter_Data.ShiftDetailId > 0 && DayShiftCounter_Data.BusinessDayId > 0) {
                    setModalOpen({
                        ...modalOpen,
                        DayModal: false,
                        ShiftModal: true,
                        CounterModal: false
                    });
                }
                else if (DayShiftCounter_Data.TerminalDetailId == 0 && DayShiftCounter_Data.ShiftDetailId == 0 && DayShiftCounter_Data.BusinessDayId > 0) {
                    setModalOpen({
                        ...modalOpen,
                        DayModal: true,
                        ShiftModal: false,
                        CounterModal: false
                    });
                }
                else if (DayShiftCounter_Data.TerminalDetailId == 0 && DayShiftCounter_Data.ShiftDetailId == 0 && DayShiftCounter_Data.BusinessDayId == 0) {
                    setModalOpen({
                        ...modalOpen,
                        DayModal: false,
                        ShiftModal: false,
                        CounterModal: false
                    });
                }
            }
        }
    }, [isDayShiftCounterCloseModalVisible, data]);


    const handleDayShiftCounter = (e, opId) => {
        e.preventDefault();

        postDayShitTerminal(opId);
    };

    const postDayShitTerminal = (operationId) => {

        let terminalRandom_Key = Date.now().toString(36) +
            Math.random().toString(36).substring(2, 9);

        let terminalUniqueKey = '';
        if (operationId === 1) {
            terminalUniqueKey = localStorage.getItem(TERMINAL_UNIQUE_ID);
            if (terminalUniqueKey === null || terminalUniqueKey === '') {
                terminalUniqueKey = terminalRandom_Key;
                localStorage.setItem(TERMINAL_UNIQUE_ID, terminalUniqueKey);
            }
        }
        if (operationId === 6) {
            terminalUniqueKey = localStorage.getItem(TERMINAL_UNIQUE_ID);
            if (terminalUniqueKey === null || terminalUniqueKey === '') {
                terminalUniqueKey = terminalRandom_Key;
                localStorage.setItem(TERMINAL_UNIQUE_ID, terminalUniqueKey);
            }
        } else if (operationId === 7) {
            terminalUniqueKey = localStorage.getItem(TERMINAL_UNIQUE_ID);
            if (terminalUniqueKey !== null) {
                localStorage.setItem(TERMINAL_UNIQUE_ID, '');
            }
        }

        const counterData = DayShiftCounterData?.find(a => a.TerminalId === data?.TerminalId);

        postRequest(
            '/BusinessDayShiftTerminal',
            {
                ...data,
                BranchId: data.BranchId,
                OperationId: operationId,
                CompanyId: userData.CompanyId,
                UserId: userData.UserId,
                UserIP: '12.1.1.2',
                UniqueId: terminalUniqueKey,
                TerminalDetailId: (data?.TerminalDetailId || counterData?.TerminalDetailId) ?? 0,
                ShiftDetailId: (data?.ShiftDetailId || counterData?.ShiftDetailId) ?? 0,
                BusinessDayId: (data?.BusinessDayId || counterData?.BusinessDayId) ?? 0,
            },
            controller,
        )
            .then((response) => {
                setModalLoading(false);

                if (response?.error === true) {
                    message.error(response?.errorMessage);
                    return;
                }
                if (response?.data?.response === false) {
                    message.error(response?.DataSet?.Table?.errorMessage);
                    return;
                }
                message.success(response.successMessage);

                const currentBranchData = response?.data?.DataSet?.Table1
                    .filter(a => a.BranchId === data?.BranchId);

                if (currentBranchData?.length > 0) {

                    let terminalObj = null;

                    if (data?.TerminalId > 0) {
                        terminalObj = currentBranchData?.find(a => a.TerminalId === data?.TerminalId);

                        if (terminalObj) {
                            setSelectedTerminalInfo(terminalObj);
                        }

                        if (operationId === 7) {
                            const finalTerminalDetailId = (data?.TerminalDetailId || counterData?.TerminalDetailId) ?? 0;
                            const finalBusinessDayId = (terminalObj?.BusinessDayId || currentBranchData[0]?.BusinessDayId || data?.BusinessDayId || counterData?.BusinessDayId) ?? 0;

                            if (finalTerminalDetailId > 0 && finalBusinessDayId > 0 && data?.BranchId) {

                                setFinancialReportOperationId(6);

                                GetFinancialReportData(6, {
                                    TerminalDetailId: finalTerminalDetailId,
                                    BusinessDayId: finalBusinessDayId,
                                }).then((result) => {

                                    if (result) {
                                        setFinancialModal(true);
                                        setFinancialReportData(result);

                                        setProductSaleReportOperationId(8);

                                        GetProductSaleData(8, {
                                            TerminalDetailId: finalTerminalDetailId,
                                            BusinessDayId: finalBusinessDayId,
                                        }).then((result) => {

                                            if (result) {
                                                setProductSaleModal(true);
                                                setProductSaleData(result);
                                            }
                                        });
                                    }
                                });
                            }
                        }

                        if (operationId === 5) {
                            const finalShiftDetailId = (data?.ShiftDetailId || counterData?.ShiftDetailId) ?? 0;
                            const finalBusinessDayId = (terminalObj?.BusinessDayId || currentBranchData[0]?.BusinessDayId ||
                                data?.BusinessDayId || counterData?.BusinessDayId) ?? 0;

                            if (finalShiftDetailId > 0 && finalBusinessDayId > 0 && data?.BranchId) {

                                setFinancialReportOperationId(5);

                                GetFinancialReportData(5, {
                                    ShiftDetailId: finalShiftDetailId,
                                    BusinessDayId: finalBusinessDayId,
                                }).then((result) => {

                                    if (result) {
                                        setFinancialModal(true);
                                        setFinancialReportData(result);

                                        setProductSaleReportOperationId(7);

                                        GetProductSaleData(7, {
                                            ShiftDetailId: finalShiftDetailId,
                                            BusinessDayId: finalBusinessDayId,
                                        }).then((result) => {

                                            if (result) {
                                                setProductSaleModal(true);
                                                setProductSaleData(result);
                                            }
                                        });
                                    }
                                });
                            }
                        }

                        if (operationId === 3) {
                            // const finalBusinessDayId = (data?.ShiftDetailId || counterData?.ShiftDetailId) ?? 0;
                            const finalBusinessDayId = (terminalObj?.BusinessDayId || currentBranchData[0]?.BusinessDayId ||
                                data?.BusinessDayId || counterData?.BusinessDayId) ?? 0;

                            if (finalBusinessDayId > 0 && data?.BranchId) {

                                setFinancialReportOperationId(4);

                                GetFinancialReportData(4, {
                                    BusinessDayId: finalBusinessDayId,
                                }).then((result) => {

                                    if (result) {
                                        setFinancialModal(true);
                                        setFinancialReportData(result);

                                        setProductSaleReportOperationId(6);

                                        GetProductSaleData(6, {
                                            BusinessDayId: finalBusinessDayId,
                                        }).then((result) => {

                                            if (result) {
                                                setProductSaleModal(true);
                                                setProductSaleData(result);
                                            }
                                        });
                                    }
                                });
                            }
                        }

                        const updatedData = currentBranchData.map(item => {
                            if (item.TerminalId === data.TerminalId) {
                                return {
                                    ...item,
                                    TerminalDetailId: terminalObj?.TerminalDetailId ?? 0,
                                    IsSelected: true,
                                };
                            } else {
                                return {
                                    ...item,
                                    IsSelected: false,
                                };
                            }
                        });

                        setDayShiftCounterData(updatedData);
                        dispatch({
                            type: "POS_DAY_SHIFT_TERMINAL",
                            payload: updatedData || []
                        });


                        const printCounterOpenRpt = response?.data?.DataSet?.Table[0]?.CounterReport ?? 0;

                        if (operationId === 6 && data?.TerminalId > 0 && printCounterOpenRpt === 1) {
                            const openingTable = response?.data?.DataSet?.Table2;
                            const resolvedShift =
                                selectedShiftInfo ||
                                POSData?.ShiftList?.find((shift) =>
                                    shift.ShiftId === (terminalObj?.ShiftId ?? data?.ShiftId)
                                ) ||
                                (terminalObj?.ShiftName
                                    ? { ShiftName: terminalObj.ShiftName, ShiftId: terminalObj.ShiftId }
                                    : null);

                            let openingDateTime = new Date().toISOString();
                            if (Array.isArray(openingTable) && openingTable.length > 0) {
                                openingDateTime =
                                    openingTable[0]?.TerminalOpeningDateTime ||
                                    openingTable[0]?.TerminalOpeningDate ||
                                    openingTable[0]?.CreatedOn ||
                                    openingDateTime;
                            }

                            const openingAmountValue = Number(
                                data?.TerminalOpeningAmount ??
                                terminalObj?.TerminalOpeningAmount ??
                                0
                            );

                            setPendingTerminalReport({
                                companyName: userData.CompanyName || "",
                                branchName:
                                    terminalObj?.BranchName ||
                                    data.BranchName ||
                                    currentBranchData[0]?.BranchName ||
                                    "",
                                terminalName:
                                    terminalObj?.TerminalName ||
                                    selectedTerminalInfo?.TerminalName ||
                                    data.TerminalName ||
                                    "",
                                openingAmount: openingAmountValue,
                                openedBy: userData.Name || userData.UserName || "",
                                openingDateTime,
                                shiftName: resolvedShift?.ShiftName || "",
                                businessDayId:
                                    terminalObj?.BusinessDayId ??
                                    currentBranchData[0]?.BusinessDayId ??
                                    data.BusinessDayId ??
                                    0,
                                shiftId:
                                    resolvedShift?.ShiftId ??
                                    terminalObj?.ShiftId ??
                                    data.ShiftId ??
                                    0,
                                terminalId: terminalObj?.TerminalId ?? data.TerminalId ?? 0,
                                reference: terminalUniqueKey,
                                notes: openingTable?.[0]?.Remarks || "",
                            });
                        }

                        if (operationId === 6) {
                            localStorage.setItem('SelectedTerminalId', data?.TerminalId);

                            dispatch({
                                type: "POS_TERMINAL_ORDERMODE",
                                payload: response?.data?.DataSet?.Table2 || []
                            });
                        }
                    }
                    else {
                        setDayShiftCounterData(response?.data?.DataSet?.Table1);
                        dispatch({
                            type: "POS_DAY_SHIFT_TERMINAL",
                            payload: response?.data?.DataSet?.Table1 || []
                        });
                    }

                    const resolvedShift =
                        selectedShiftInfo ||
                        POSData?.ShiftList?.find((shift) =>
                            shift.ShiftId === (data?.ShiftId || currentBranchData[0]?.ShiftId)
                        ) ||
                        (currentBranchData[0]?.ShiftName
                            ? {
                                ShiftName: currentBranchData[0]?.ShiftName,
                                ShiftId: currentBranchData[0]?.ShiftId,
                            }
                            : null);

                    const shiftTable = response?.data?.DataSet?.Table2;
                    const shiftRecord = Array.isArray(shiftTable) && shiftTable.length > 0
                        ? shiftTable.find(
                            (item) =>
                                item.ShiftId === (resolvedShift?.ShiftId || data?.ShiftId)
                        ) || shiftTable[0]
                        : null;

                    setData({
                        ...data,
                        BusinessDayId: currentBranchData[0]?.BusinessDayId ?? 0,
                        BranchName: currentBranchData[0]?.BranchName,
                        ShiftDetailId: currentBranchData[0]?.ShiftDetailId ?? 0,
                        ShiftId: currentBranchData[0]?.ShiftId ?? data.ShiftId ?? 0,
                        ShiftName: resolvedShift?.ShiftName || data.ShiftName || currentBranchData[0]?.ShiftName || "",
                        TerminalDetailId: terminalObj?.TerminalDetailId ?? 0,
                        IsSelected: (terminalObj?.TerminalDetailId === 0 || terminalObj?.TerminalDetailId === null) ? false : true,
                    });

                    if (operationId === 4) {
                        const openingDateTime =
                            shiftRecord?.ShiftOpeningDateTime ||
                            shiftRecord?.ShiftStartDateTime ||
                            shiftRecord?.OpeningDateTime ||
                            currentBranchData[0]?.ShiftOpeningDateTime ||
                            currentBranchData[0]?.ShiftStartDateTime ||
                            new Date().toISOString();

                        setPendingShiftReport({
                            companyName: userData.CompanyName || "",
                            branchName: currentBranchData[0]?.BranchName || data.BranchName || "",
                            shiftName: resolvedShift?.ShiftName || data.ShiftName || "",
                            openedBy: userData.Name || userData.UserName || "",
                            openingDateTime,
                            businessDayId:
                                currentBranchData[0]?.BusinessDayId ??
                                data.BusinessDayId ??
                                null,
                            shiftId:
                                resolvedShift?.ShiftId ??
                                data.ShiftId ??
                                shiftRecord?.ShiftId ??
                                null,
                            shiftDetailId:
                                currentBranchData[0]?.ShiftDetailId ??
                                data.ShiftDetailId ??
                                shiftRecord?.ShiftDetailId ??
                                null,
                            notes:
                                shiftRecord?.Remarks ||
                                shiftRecord?.Notes ||
                                currentBranchData[0]?.Remarks ||
                                "",
                        });
                    }

                    if (operationId === 7 || operationId === 5 || operationId === 3) {
                        setIsDayShiftCounterCloseModalVisible(true);
                    }
                    else if (operationId === 6 || operationId === 4 || operationId === 2) {
                        setIsDayShiftCounterCloseModalVisible(false);

                        dispatch({ type: "REFRESH_STATS", payload: 1 });
                    }

                    // if (operationId != 1) {
                    //     setModalOpen({
                    //         ...modalOpen,
                    //         DayModal: (currentBranchData[0]?.BusinessDayId > 0 && currentBranchData[0]?.ShiftDetailId == 0) ? true : false,
                    //         ShiftModal: (currentBranchData[0]?.ShiftDetailId > 0 && terminalObj?.TerminalDetailId == 0) ? true : false,
                    //         CounterModal: terminalObj?.TerminalDetailId > 0 ? false : true
                    //     });
                    // }

                    // if (data?.TerminalId > 0 && operationId != 7) {
                    //     navigate('/OrderRecall');
                    // }
                }
            })
            .catch((error) => console.error(error));
    };

    const selectOpenedCounter = () => {


        // let terminalUniqueKey = localStorage.getItem(TERMINAL_UNIQUE_ID);

        // const terminalData = POSData?.DayShiftCounter?.map(item => ({
        //     ...item,
        //     IsSelected: item.TerminalId === data?.TerminalId
        // }));

        // dispatch({ type: "POS_DAY_SHIFT_TERMINAL", payload: terminalData || [] });

        // setModalOpen({
        //     ...modalOpen,
        //     CounterModal: false,
        //     ShiftModal: false,
        //     DayModal: false
        // });
        // setIsDayShiftCounterModalVisible(false);


        // localStorage.setItem('SelectedTerminalId', data?.TerminalId);

        // setDayShiftCounterData(terminalData);

        // // navigate('/OrderRecall');

        postDayShitTerminal(6);
    };

    return (
        <div>
            {/* DAY MODAL */}
            <ModalComponent
                title='Business Day'

                isModalVisible={modalOpen.DayModal}

                footer={null}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {modalLoading && <Spin />}
                    <p>
                        {moment().format('dddd') + ' - ' + moment().format('MMM Do YY')}
                    </p>
                </div>
                <FormContainer
                    onSubmit={(e) =>
                        // handleDayShiftCounter(e, data.BusinessDayId > 0 ? 3 : 2)
                        handleDayShiftCounter(e, (isDayShiftCounterCloseModalVisible == true || data.BusinessDayId > 0) ? 3 : 2)
                    }>
                    <FormSelect
                        colSpan={24}
                        listItem={userData.userBranchList || []}
                        idName='BranchId'
                        valueName='BranchName'
                        size={INPUT_SIZE}
                        name='BranchId'
                        label='Branch'
                        value={data.BranchId}
                        onChange={(e) => {
                            const currentBranchData = DayShiftCounterData
                                .filter(a => a.BranchId === e.value);

                            setSelectedShiftInfo(null);
                            setSelectedTerminalInfo(null);

                            setData({
                                ...data,
                                BranchId: e.value,
                                BusinessDayId: currentBranchData[0]?.BusinessDayId ?? 0,
                                BranchName: currentBranchData[0]?.BranchName,
                                ShiftDetailId: currentBranchData[0]?.ShiftDetailId ?? 0,
                                ShiftId: currentBranchData[0]?.ShiftId ?? 0,
                                TerminalId: 0,
                                TerminalName: "",
                            })
                        }
                        }
                        required
                    />
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #eee',
                            paddingTop: '15px',
                            marginTop: '24px',
                        }}
                        align='right'>
                        <Button
                            type='default'
                            onClick={() => setIsDayShiftCounterModalVisible(false)}>
                            Close
                        </Button>

                        {/* {data?.BusinessDayId > 0 ?
                            <FormButton type='primary' title='Select' /> :
                            <FormButton htmlType='submit' type='primary' title='Start Day' />
                        } */}

                        {isDayShiftCounterCloseModalVisible === false && data?.BusinessDayId == 0 &&
                            <FormButton htmlType='submit' type='primary' title='Start Day' />
                        }

                        {isDayShiftCounterCloseModalVisible === true &&
                            data?.BusinessDayId > 0 &&
                            data?.ShiftDetailId == 0 &&
                            data?.TerminalDetailId == 0 &&

                            <FormButton htmlType='submit' type='primary' title='End Day' />
                        }

                        {isDayShiftCounterCloseModalVisible === true &&
                            data?.BusinessDayId > 0 &&
                            data?.ShiftDetailId > 0 &&
                            data?.TerminalDetailId == 0 &&

                            <FormButton type='primary' title='Select' />
                        }
                    </div>
                </FormContainer>
            </ModalComponent>

            {/* SHIFT DAY */}

            <ModalComponent
                title='Shift'
                isModalVisible={modalOpen.ShiftModal}
                footer={null}>
                <FormContainer
                    onSubmit={(e) =>
                        handleDayShiftCounter(e, (isDayShiftCounterCloseModalVisible == true || data.ShiftDetailId > 0) ? 5 : 4)
                    }
                >
                    {modalLoading && <Spin />}
                    <FormSelect
                        colSpan={24}
                        listItem={POSData?.ShiftList ?? []}
                        idName='ShiftId'
                        valueName='ShiftName'
                        size={INPUT_SIZE}
                        name='ShiftId'
                        label='Select Shift'
                        value={data.ShiftId}
                        onChange={(e) => {
                            const shift = POSData?.ShiftList?.find((item) => item.ShiftId === e.value);
                            setSelectedShiftInfo(shift || null);
                            setData({
                                ...data,
                                ShiftId: e.value,
                                ShiftName: shift?.ShiftName || "",
                                ShiftDetailId: shift?.ShiftDetailId ?? data.ShiftDetailId ?? 0,
                            });
                        }}
                    />
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #eee',
                            paddingTop: '15px',
                            marginTop: '24px',
                        }}
                        align='right'>
                        <Button
                            onClick={() =>
                                setModalOpen({
                                    ...modalOpen,
                                    CounterModal: false,
                                    ShiftModal: false,
                                    DayModal: true
                                })
                            }>
                            Cancel
                        </Button>

                        {isDayShiftCounterCloseModalVisible === false &&
                            <FormButton htmlType='submit' type='primary' title='Start Shift' />
                        }

                        {isDayShiftCounterCloseModalVisible === true &&
                            <FormButton htmlType='submit' type='primary' title='End Shift' />
                        }
                    </div>
                </FormContainer>
            </ModalComponent>

            {/* COUNTER */}
            <ModalComponent
                title='Counter'
                isModalVisible={modalOpen.CounterModal}
                footer={null}>
                <FormContainer
                    onSubmit={(e) =>
                        handleDayShiftCounter(e, (isDayShiftCounterCloseModalVisible == true || data.TerminalDetailId > 0) ? 7 : 6)
                    }
                >
                    {modalLoading && <Spin />}

                    <FormSelect
                        colSpan={12}
                        listItem={!isDayShiftCounterCloseModalVisible ?
                            (POSData?.TerminalList?.filter(a => a.BranchId === data.BranchId) || []) :
                            (DayShiftCounterData?.filter(a => a.BranchId === data.BranchId && a.IsCounterOpen == true && POSData?.TerminalList?.some(t => t.TerminalId === a.TerminalId)) || [])
                        }
                        idName='TerminalId'
                        valueName='TerminalName'
                        size={INPUT_SIZE}
                        name='TerminalId'
                        label='Select Counter'
                        value={data.TerminalId}
                        onChange={(e) => {

                            const counterData =
                                DayShiftCounterData?.find(a => a.TerminalId === e.value);

                            const availableTerminals = !isDayShiftCounterCloseModalVisible
                                ? (POSData?.TerminalList?.filter(a => a.BranchId === data.BranchId) || [])
                                : (DayShiftCounterData?.filter(a => a.BranchId === data.BranchId && a.IsCounterOpen == true && POSData?.TerminalList?.some(t => t.TerminalId === a.TerminalId)) || []);

                            const selectedTerminal = availableTerminals.find((item) => item.TerminalId === e.value) || counterData || null;

                            setSelectedTerminalInfo(selectedTerminal);

                            setData({
                                ...data,
                                TerminalId: e.value,
                                TerminalName: selectedTerminal?.TerminalName || "",
                                IsTerminalOpen: counterData?.IsCounterOpen ?? false,
                                // TerminalDetailId: counterData?.TerminalDetailId ?? 0,
                                // ShiftDetailId: counterData?.ShiftDetailId ?? 0,
                                // BusinessDayId: counterData?.BusinessDayId ?? 0,
                            });

                        }}
                        required
                    />


                    {!data?.IsTerminalOpen && isDayShiftCounterCloseModalVisible === false &&
                        <FormTextField
                            colSpan={12}
                            placeholder='Counter Opening Amount'
                            style={{ width: '250px' }}
                            label='Counter Opening Amount'
                            required
                            name='TerminalOpeningAmount'
                            value={data.TerminalOpeningAmount}
                            isNumber='true'
                            onClick={(e) => e.target.select()}
                            min='0'
                            onChange={(e) =>
                                setData({ ...data, TerminalOpeningAmount: e.value })
                            }
                        />
                    }

                    {data?.IsTerminalOpen && isDayShiftCounterCloseModalVisible === true &&
                        <FormTextField
                            colSpan={12}
                            placeholder='Counter Closing Amount'
                            style={{ width: '250px' }}
                            label='Counter Closing Amount'
                            required
                            name='TerminalClosingAmount'
                            value={data.TerminalClosingAmount}
                            isNumber='true'
                            onClick={(e) => e.target.select()}
                            min='0'
                            onChange={(e) =>
                                setData({ ...data, TerminalClosingAmount: e.value })
                            }
                        />
                    }

                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #eee',
                            paddingTop: '15px',
                            marginTop: '24px',
                        }}
                        align='right'>


                        <Button
                            onClick={() => {
                                setModalOpen({
                                    ...modalOpen,
                                    CounterModal: false,
                                    ShiftModal: false,
                                    DayModal: false
                                });
                                setIsDayShiftCounterModalVisible(false);
                            }
                            }>
                            Cancel
                        </Button>

                        {isDayShiftCounterCloseModalVisible === false &&
                            <>
                                {!data.IsTerminalOpen ?
                                    <FormButton
                                        title={
                                            'Open Counter'
                                        }
                                        type='primary'
                                        htmlType='submit'
                                    /> :
                                    <FormButton
                                        title={
                                            'Select Counter'
                                        }
                                        type='primary'
                                        onClick={() => {

                                            selectOpenedCounter();
                                        }
                                        }
                                    />}
                            </>
                        }

                        {data.IsTerminalOpen && isDayShiftCounterCloseModalVisible === true &&
                            <FormButton
                                title={
                                    'Close Counter'
                                }
                                type='primary'
                                htmlType='submit'

                            />
                        }
                    </div>

                </FormContainer>

            </ModalComponent>
            <div style={{ display: "none" }}>
                <TerminalOpeningReport ref={terminalReportRef} data={pendingTerminalReport} />
                <ShiftOpeningReport ref={shiftReportRef} data={pendingShiftReport} />
                <FinancialReportModal
                    financialModal={financialModal}
                    setFinancialModal={setFinancialModal}
                    record={financialReportData}
                    operationId={financialReportOperationId}
                />
                <ProductSaleReportModal
                    productSaleModal={productSaleModal}
                    setProductSaleModal={setProductSaleModal}
                    record={productSaleData}
                    operationId={productSaleReportOperationId}
                />
            </div>
        </div >
    );
};

export default DayShiftCounterModal;